module.exports = __webpack_public_path__ + "img/bt.acfa822.svg";